<script>
import { mapActions } from 'vuex';

import request from '@/services/request';

import Catalogue from '@/services/catalogue';

import ModalFormComponent from '@/components/debts_bill/ModalDebtsBillFormComponent.vue';

export default {

    components: {
        ModalFormComponent,
    },

    props: {
        prop_edit: {
            default: true,
        }
    },

    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            load: false,
            bills: [],
            id: 0,
        }
    },

    methods: {

        deletePay(id) {

            let tit = 'Eliminar factura';
            let txt = '¿Seguro que quiere eliminar esta factura? Esta acción no se puede deshacer.';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d84d5d',
                cancelButtonColor: '#6b7280',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {

                if (result.isConfirmed) {

                    let _endpoint = `/dues_bill/${id}`;

                    try {

                        let response = await request
                            .destroy(_endpoint)
                            .then(function (response) {
                                return response;
                            });

                        this.list();

                        this.successNotification(
                            response.data.message
                        );

                    } catch (error) {

                        this.errors =
                            await this.errorNotification(error);

                    }

                }

            });

        },

        async form(data = {}) {

            Event.$emit(
                'event-show-addCreateBillFormDebts',
                this.id,
                data
            );

        },

        async list() {

            this.load = true;

            let service = request;

            let _endpoint =
                '/dues_bill?id=' + this.id;

            try {

                let { data } =
                    await service.get(_endpoint);

                if (data) {

                    this.bills = data;

                }

            } catch (error) {

                console.log(error);

            } finally {

                this.load = false;

            }

        },

        closedModal() {

            this.load = false;
            this.errors = {};
            this.send = false;
            this.id = 0;
            this.bills = [];

            this.$modal.hide(
                'addCreateBillDebt'
            );

        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        })

    },

    created() {

        Event.$on(
            "event-show-addCreateBillDebts",
            async (id) => {

                this.load = true;

                this.$modal.show(
                    'addCreateBillDebt'
                );

                this.id = id;

                await this.list();

            }
        );

        Event.$on(
            "event-show-loadBillFormDebts",
            async () => {

                await this.list();

            }
        );

    },

    watch: {
    }

}
</script>

<template>

    <modal
        name="addCreateBillDebt"
        :width="'80%'"
        :height="'auto'"
        :adaptive="true"
        :scrollable="true"
        :click-to-close="false"
    >

        <div class="debt-bill-modal">

            <!-- =====================================================
                HEADER
            ====================================================== -->
            <div class="form-header">

                <div class="form-header__content">

                    <div class="form-header__icon">
                        <i class="fa-solid fa-file-invoice-dollar"></i>
                    </div>

                    <div>

                        <h5 class="form-header__title">
                            Facturación
                        </h5>

                        <p class="form-header__subtitle">
                            Consulta y administra las facturas asociadas al adeudo.
                        </p>

                    </div>

                </div>

                <button
                    type="button"
                    class="form-close"
                    title="Cerrar"
                    aria-label="Cerrar"
                    @click="closedModal()"
                >
                    <i class="fa-solid fa-xmark"></i>
                </button>

            </div>


            <!-- =====================================================
                BODY
            ====================================================== -->
            <div class="form-body">

                <section class="form-section">

                    <!-- =============================================
                        SECTION HEADER
                    ============================================== -->
                    <div class="section-header section-header--actions">

                        <div class="section-header__left">

                            <div class="section-number">
                                <i class="fa-solid fa-file-invoice"></i>
                            </div>

                            <div>

                                <h6 class="section-title">
                                    Facturas registradas
                                </h6>

                                <p class="section-description">
                                    Visualiza los documentos generados y administra su información.
                                </p>

                            </div>

                        </div>


                        <div class="section-actions">

                            <span
                                v-if="!load"
                                class="records-badge"
                            >
                                {{ bills.length }}
                                {{ bills.length === 1 ? 'factura' : 'facturas' }}
                            </span>

                            <button
                                type="button"
                                class="btn-add-bill"
                                @click="form()"
                            >
                                <i class="fa-solid fa-plus"></i>

                                <span>
                                    Agregar factura
                                </span>
                            </button>

                        </div>

                    </div>


                    <!-- =============================================
                        LOADING
                    ============================================== -->
                    <div
                        v-if="load"
                        class="loading-state"
                    >

                        <div class="loading-state__icon">

                            <i class="fa-solid fa-circle-notch fa-spin"></i>

                        </div>

                        <div>

                            <strong>
                                Consultando facturas
                            </strong>

                            <p>
                                Estamos obteniendo la información registrada.
                            </p>

                        </div>

                    </div>


                    <!-- =============================================
                        TABLE
                    ============================================== -->
                    <div
                        v-else-if="bills.length > 0"
                        class="bill-table-wrapper"
                    >

                        <table class="bill-table">

                            <thead>

                                <tr>

                                    <th class="bill-id-column">
                                        Factura
                                    </th>

                                    <th class="bill-date-column">
                                        Fecha
                                    </th>

                                    <th>
                                        Comentarios
                                    </th>

                                    <th class="documents-column">
                                        Documentos
                                    </th>

                                    <th class="actions-column">
                                        Acciones
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                <tr
                                    v-for="(bill, index) in bills"
                                    :key="index"
                                >

                                    <!-- ID -->
                                    <td>

                                        <div class="bill-identifier">

                                            <div class="bill-identifier__icon">

                                                <i class="fa-solid fa-file-invoice"></i>

                                            </div>

                                            <div>

                                                <small>
                                                    ID
                                                </small>

                                                <strong>
                                                    #{{ bill.id }}
                                                </strong>

                                            </div>

                                        </div>

                                    </td>


                                    <!-- FECHA -->
                                    <td>

                                        <div class="date-information">

                                            <i class="fa-regular fa-calendar"></i>

                                            <span>
                                                {{ bill.date | toDateTime }}
                                            </span>

                                        </div>

                                    </td>


                                    <!-- COMENTARIOS -->
                                    <td>

                                        <div
                                            v-if="bill.comment"
                                            class="bill-comment"
                                        >
                                            {{ bill.comment }}
                                        </div>

                                        <span
                                            v-else
                                            class="empty-value"
                                        >
                                            Sin comentarios
                                        </span>

                                    </td>


                                    <!-- DOCUMENTOS -->
                                    <td>

                                        <div class="document-actions">

                                            <a
                                                v-if="bill.xml"
                                                target="_blank"
                                                :href="`${globalUrlFiles}${bill.xml}`"
                                                class="document-button document-button--xml"
                                                title="Abrir archivo XML"
                                            >

                                                <i class="fa-solid fa-code"></i>

                                                <span>
                                                    XML
                                                </span>

                                            </a>


                                            <a
                                                v-if="bill.pdf"
                                                target="_blank"
                                                :href="`${globalUrlFiles}${bill.pdf}`"
                                                class="document-button document-button--pdf"
                                                title="Abrir archivo PDF"
                                            >

                                                <i class="fa-regular fa-file-pdf"></i>

                                                <span>
                                                    PDF
                                                </span>

                                            </a>


                                            <span
                                                v-if="!bill.xml && !bill.pdf"
                                                class="empty-value"
                                            >
                                                Sin archivos
                                            </span>

                                        </div>

                                    </td>


                                    <!-- ACTIONS -->
                                    <td>

                                        <div class="row-actions">

                                            <button
                                                type="button"
                                                class="action-button action-button--edit"
                                                title="Editar factura"
                                                @click="form(bill)"
                                            >

                                                <i class="fa-solid fa-pen"></i>

                                                <span>
                                                    Editar
                                                </span>

                                            </button>


                                            <button
                                                type="button"
                                                class="action-button action-button--delete"
                                                title="Eliminar factura"
                                                @click="deletePay(bill.id)"
                                            >

                                                <i class="fa-solid fa-trash-can"></i>

                                                <span>
                                                    Eliminar
                                                </span>

                                            </button>

                                        </div>

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>


                    <!-- =============================================
                        EMPTY
                    ============================================== -->
                    <div
                        v-else
                        class="empty-state"
                    >

                        <div class="empty-state__icon">

                            <i class="fa-solid fa-file-circle-plus"></i>

                        </div>

                        <div class="empty-state__content">

                            <strong>
                                Todavía no hay facturas registradas
                            </strong>

                            <p>
                                Agrega la primera factura asociada a este adeudo.
                            </p>

                            <button
                                type="button"
                                class="empty-state__button"
                                @click="form()"
                            >

                                <i class="fa-solid fa-plus"></i>

                                Agregar primera factura

                            </button>

                        </div>

                    </div>

                </section>

            </div>


            <!-- =====================================================
                FOOTER
            ====================================================== -->
            <div class="form-footer">

                <button
                    type="button"
                    class="btn btn-light footer-button"
                    @click="closedModal()"
                >

                    <i class="fa-solid fa-arrow-left"></i>

                    Regresar

                </button>

            </div>


            <!-- FORMULARIO DE ALTA / EDICIÓN -->
            <ModalFormComponent
                :prop_edit="true"
            />

        </div>

    </modal>

</template>


<style scoped>

.debt-bill-modal {

    --primary: #5672a5;
    --primary-dark: #304d7d;
    --primary-soft: #eef3fb;

    --success: #269b74;
    --success-soft: #eaf8f3;

    --warning: #d99b24;
    --warning-soft: #fff8e8;

    --danger: #d84d5d;
    --danger-soft: #fff0f2;

    --border: #dfe5ee;

    --surface: #ffffff;
    --background: #f5f7fb;

    --text: #1f2937;
    --muted: #6b7280;

    background: var(--background);
    color: var(--text);

    min-height: 400px;

}


/* ==============================================================
    HEADER
============================================================== */

.form-header {

    align-items: center;

    background: linear-gradient(
        135deg,
        var(--primary-dark),
        var(--primary)
    );

    color: #ffffff;

    display: flex;

    justify-content: space-between;

    padding: 18px 22px;

}


.form-header__content {

    align-items: center;

    display: flex;

    gap: 14px;

}


.form-header__icon {

    align-items: center;

    background: rgba(255, 255, 255, 0.15);

    border:
        1px solid rgba(255, 255, 255, 0.2);

    border-radius: 12px;

    display: flex;

    font-size: 22px;

    height: 46px;

    justify-content: center;

    width: 46px;

}


.form-header__title {

    font-size: 18px;

    font-weight: 700;

    margin: 0;

}


.form-header__subtitle {

    color: rgba(255, 255, 255, 0.78);

    font-size: 12px;

    margin: 3px 0 0;

}


.form-close {

    align-items: center;

    background: rgba(255, 255, 255, 0.12);

    border: 0;

    border-radius: 50%;

    color: #ffffff;

    cursor: pointer;

    display: flex;

    height: 36px;

    justify-content: center;

    transition: 0.2s ease;

    width: 36px;

}


.form-close:hover {

    background: rgba(255, 255, 255, 0.24);

    transform: rotate(90deg);

}


/* ==============================================================
    BODY
============================================================== */

.form-body {

    max-height: calc(100vh - 185px);

    overflow-y: auto;

    padding: 22px;

}


/* ==============================================================
    SECTION
============================================================== */

.form-section {

    background: var(--surface);

    border: 1px solid var(--border);

    border-radius: 12px;

    box-shadow:
        0 3px 10px rgba(15, 23, 42, 0.04);

    overflow: hidden;

}


.section-header {

    align-items: flex-start;

    display: flex;

    gap: 12px;

    padding: 20px;

}


.section-header--actions {

    align-items: center;

    justify-content: space-between;

}


.section-header__left {

    align-items: flex-start;

    display: flex;

    gap: 12px;

}


.section-number {

    align-items: center;

    background: var(--primary-soft);

    border-radius: 50%;

    color: var(--primary-dark);

    display: flex;

    flex: 0 0 auto;

    font-size: 13px;

    height: 30px;

    justify-content: center;

    width: 30px;

}


.section-title {

    color: var(--text);

    font-size: 15px;

    font-weight: 700;

    margin: 1px 0 3px;

}


.section-description {

    color: var(--muted);

    font-size: 12px;

    margin: 0;

}


.section-actions {

    align-items: center;

    display: flex;

    gap: 10px;

}


/* ==============================================================
    COUNT
============================================================== */

.records-badge {

    background: #f3f5f8;

    border: 1px solid var(--border);

    border-radius: 999px;

    color: var(--muted);

    font-size: 10px;

    font-weight: 600;

    padding: 6px 10px;

}


/* ==============================================================
    ADD BUTTON
============================================================== */

.btn-add-bill {

    align-items: center;

    background: var(--success);

    border: 1px solid var(--success);

    border-radius: 7px;

    color: #ffffff;

    cursor: pointer;

    display: inline-flex;

    font-size: 11px;

    font-weight: 600;

    gap: 7px;

    min-height: 35px;

    padding: 7px 12px;

    transition: 0.2s ease;

}


.btn-add-bill:hover {

    box-shadow:
        0 4px 10px rgba(38, 155, 116, 0.18);

    filter: brightness(0.96);

    transform: translateY(-1px);

}


/* ==============================================================
    TABLE
============================================================== */

.bill-table-wrapper {

    border-top:
        1px solid var(--border);

    max-height: 480px;

    overflow: auto;

}


.bill-table {

    border-collapse: separate;

    border-spacing: 0;

    margin: 0;

    min-width: 900px;

    width: 100%;

}


.bill-table th {

    background: #f3f5f8;

    border-bottom:
        1px solid var(--border);

    color: #4b5563;

    font-size: 10px;

    font-weight: 700;

    letter-spacing: 0.02em;

    padding: 11px 14px;

    position: sticky;

    text-transform: uppercase;

    top: 0;

    z-index: 2;

}


.bill-table td {

    border-bottom:
        1px solid #edf0f4;

    color: #374151;

    font-size: 12px;

    padding: 13px 14px;

    vertical-align: middle;

}


.bill-table tbody tr {

    transition:
        background 0.15s ease;

}


.bill-table tbody tr:hover {

    background: #fafbfd;

}


.bill-table tbody tr:last-child td {

    border-bottom: 0;

}


.bill-id-column {

    width: 115px;

}


.bill-date-column {

    min-width: 170px;

    width: 190px;

}


.documents-column {

    min-width: 150px;

    width: 170px;

}


.actions-column {

    min-width: 205px;

    width: 205px;

}


/* ==============================================================
    BILL ID
============================================================== */

.bill-identifier {

    align-items: center;

    display: flex;

    gap: 9px;

}


.bill-identifier__icon {

    align-items: center;

    background: var(--primary-soft);

    border-radius: 8px;

    color: var(--primary);

    display: flex;

    flex: 0 0 auto;

    height: 34px;

    justify-content: center;

    width: 34px;

}


.bill-identifier small {

    color: var(--muted);

    display: block;

    font-size: 9px;

    line-height: 1;

}


.bill-identifier strong {

    color: var(--text);

    display: block;

    font-size: 12px;

    margin-top: 3px;

}


/* ==============================================================
    DATE
============================================================== */

.date-information {

    align-items: center;

    color: #4b5563;

    display: flex;

    gap: 7px;

}


.date-information i {

    color: var(--primary);

}


/* ==============================================================
    COMMENTS
============================================================== */

.bill-comment {

    color: #4b5563;

    line-height: 1.45;

    max-width: 480px;

}


.empty-value {

    color: #9ca3af;

    font-size: 11px;

    font-style: italic;

}


/* ==============================================================
    DOCUMENTS
============================================================== */

.document-actions {

    align-items: center;

    display: flex;

    flex-wrap: wrap;

    gap: 6px;

}


.document-button {

    align-items: center;

    border-radius: 6px;

    display: inline-flex;

    font-size: 10px;

    font-weight: 700;

    gap: 5px;

    padding: 6px 9px;

    text-decoration: none !important;

    transition: 0.2s ease;

}


.document-button--xml {

    background: var(--success-soft);

    border:
        1px solid #c7ecde;

    color: var(--success);

}


.document-button--xml:hover {

    background: var(--success);

    border-color: var(--success);

    color: #ffffff;

}


.document-button--pdf {

    background: var(--danger-soft);

    border:
        1px solid #f2c7cd;

    color: var(--danger);

}


.document-button--pdf:hover {

    background: var(--danger);

    border-color: var(--danger);

    color: #ffffff;

}


/* ==============================================================
    ACTIONS
============================================================== */

.row-actions {

    align-items: center;

    display: flex;

    gap: 6px;

}


.action-button {

    align-items: center;

    background: #ffffff;

    border-radius: 6px;

    cursor: pointer;

    display: inline-flex;

    font-size: 10px;

    font-weight: 600;

    gap: 5px;

    min-height: 30px;

    padding: 5px 9px;

    transition: 0.2s ease;

}


.action-button--edit {

    border:
        1px solid #cfd9ea;

    color: var(--primary-dark);

}


.action-button--edit:hover {

    background: var(--primary-soft);

    border-color: var(--primary);

    color: var(--primary-dark);

}


.action-button--delete {

    border:
        1px solid #efcbd0;

    color: var(--danger);

}


.action-button--delete:hover {

    background: var(--danger-soft);

    border-color: var(--danger);

}


/* ==============================================================
    LOADING
============================================================== */

.loading-state {

    align-items: center;

    border-top:
        1px solid var(--border);

    color: var(--muted);

    display: flex;

    gap: 14px;

    justify-content: center;

    min-height: 210px;

    padding: 30px;

}


.loading-state__icon {

    align-items: center;

    background: var(--primary-soft);

    border-radius: 50%;

    color: var(--primary);

    display: flex;

    font-size: 22px;

    height: 48px;

    justify-content: center;

    width: 48px;

}


.loading-state strong {

    color: var(--text);

    display: block;

    font-size: 13px;

}


.loading-state p {

    font-size: 11px;

    margin: 3px 0 0;

}


/* ==============================================================
    EMPTY STATE
============================================================== */

.empty-state {

    align-items: center;

    border-top:
        1px solid var(--border);

    display: flex;

    gap: 15px;

    justify-content: center;

    min-height: 240px;

    padding: 35px;

}


.empty-state__icon {

    align-items: center;

    background: var(--primary-soft);

    border-radius: 50%;

    color: var(--primary);

    display: flex;

    flex: 0 0 auto;

    font-size: 22px;

    height: 52px;

    justify-content: center;

    width: 52px;

}


.empty-state__content strong {

    color: var(--text);

    display: block;

    font-size: 13px;

}


.empty-state__content p {

    color: var(--muted);

    font-size: 11px;

    margin: 4px 0 12px;

}


.empty-state__button {

    align-items: center;

    background: var(--primary-soft);

    border: 1px solid #cfd9ea;

    border-radius: 7px;

    color: var(--primary-dark);

    cursor: pointer;

    display: inline-flex;

    font-size: 10px;

    font-weight: 700;

    gap: 6px;

    padding: 7px 10px;

}


.empty-state__button:hover {

    background: var(--primary);

    border-color: var(--primary);

    color: #ffffff;

}


/* ==============================================================
    FOOTER
============================================================== */

.form-footer {

    align-items: center;

    background: #ffffff;

    border-top:
        1px solid var(--border);

    display: flex;

    gap: 10px;

    justify-content: flex-end;

    padding: 14px 22px;

}


.footer-button {

    border: 1px solid var(--border);

    border-radius: 7px;

    color: #4b5563;

    font-size: 11px;

    min-width: 120px;

    padding: 8px 14px;

}


.footer-button i {

    margin-right: 5px;

}


/* ==============================================================
    RESPONSIVE
============================================================== */

@media (max-width: 900px) {

    .section-header--actions {

        align-items: flex-start;

        flex-direction: column;

    }


    .section-actions {

        justify-content: space-between;

        width: 100%;

    }

}


@media (max-width: 768px) {

    .form-body {

        padding: 14px;

    }


    .form-header {

        padding: 15px;

    }


    .form-header__subtitle {

        display: none;

    }


    .section-actions {

        align-items: stretch;

        flex-direction: column;

    }


    .btn-add-bill {

        justify-content: center;

        width: 100%;

    }


    .records-badge {

        text-align: center;

    }


    .form-footer {

        padding: 12px 14px;

    }


    .footer-button {

        width: 100%;

    }

}

</style>